import { useState } from 'react';
import type { Batch } from '@common/interfaces/api/batchesApi';
import type { DeclarationWithActivities } from '@common/interfaces/api/declarationsApi';
import type { AdminProcess } from './adminProcessDetailsTypes';
import { FinancialSectionCollapse } from './adminProcessFinancials/FinancialSectionCollapse';
import { FinancialSectionOld } from './adminProcessFinancials/FinancialSectionOld';

type AdminProcessDetailsFinancialStatusProps = {
    adminProcess: AdminProcess;
};

export type DeclarationWithActivitiesAndBatch = DeclarationWithActivities & { exportBatch?: Batch };

export function AdminProcessDetailsFinancialStatus({ adminProcess }: AdminProcessDetailsFinancialStatusProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <FinancialSectionCollapse
                isOpen={isOpen}
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen && <FinancialSectionOld financialStatus={adminProcess} />}
            </FinancialSectionCollapse>
        </>
    );
}
